import React, { FC } from 'react';
import { Icon } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import dayjs from 'dayjs';
import { ISocialPatent } from '@src/types/resumeDetail/socialType';
import { isUrl } from '@src/utils/tools';
import './index.scss';

interface IProps {
  data: ISocialPatent[];
  setMode: Function;
}

// 仅社招
const PatentView: FC<IProps> = (props) => {
  const { data, setMode } = props;
  const { socialResumeFormRefStore } = useRootStore();

  const storeRef = socialResumeFormRefStore;

  const handleEdit = () => {
    setMode('edit');
    storeRef.setCurrentScrollRef('patent_edit');
  };

  return (
    <div className="patent_view model_view">
      <div className="model_title">
        <div>专利</div>
        <div className="edit_icon" onClick={() => handleEdit()}>
          <Icon type="edit-o" style={{ color: '#A9AFB8', fontSize: 22 }} />
        </div>
      </div>
      {data?.map((item) => (
        <div className="model_list" key={item.renderId}>
          <div className="model_top">
            <div className="patent_name">{item.patentName}</div>
            {item.obtainDate && <div className="patent_time">{dayjs(item.obtainDate).format('YYYY/MM')}</div>}
          </div>
          <div className="model_line" />
          <div className="model_bottom">
            <div className="label">
              <div className="label_left">专利人：</div>
              <div className="label_right">{item.ownerName || '-'}</div>
            </div>

            <div className="label">
              <div className="label_left">专利描述：</div>
              <div className="label_right">{item.description || '-'}</div>
            </div>
            <div className="label label_last">
              <div className="label_left">专利链接：</div>
              <div className="label_right">
                {/* eslint-disable-next-line no-nested-ternary */}
                {item.patentUrl && isUrl(item.patentUrl) ? (
                  <a href={item.patentUrl} target="_blank" rel="noopener noreferrer">
                    {item.patentUrl}
                  </a>
                ) : item.patentUrl ? (
                  item.patentUrl
                ) : (
                  '-'
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PatentView;
